(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CoreService', CoreService);

    CoreService.$inject = ['$state', '$cookies', '$sessionStorage', 'Base64', 'moment', '$rootScope', 'DataUtils',
        '$q', '$document', 'EmployeeMenu'];

    function CoreService($state, $cookies, $sessionStorage, Base64, moment, $rootScope, DataUtils,
                         $q, $document, EmployeeMenu) {


        var facilityField = {
            HIV: {
                SOBRIETY_DATE: false,
                BED: false,
                MARKETER: false,
                ADMISSION_REP: false
            }
        }

        var service = {
            byId: byId,
            isActive: isActive,
            isDischarge: isDischarge,
            sortListName: sortListName,
            isWaiting: isWaiting,
            actualFacility: actualFacility,
            redirectSearch: redirectSearch,
            redirectPatientDetails: redirectPatientDetails,
            patientAge: patientAge,
            greaterValue: greaterValue,
            toggle: toggle,
            setCurrentEmployee: setCurrentEmployee,
            getCurrentEmployee: getCurrentEmployee,
            getAvatar: getAvatar,
            setCurrentFacility: setCurrentFacility,
            getCurrentFacility: getCurrentFacility,
            getDays: getDays,
            setUnassignedBeds: setUnassignedBeds,
            getUnassignedBeds: getUnassignedBeds,
            parseToTime: parseToTime,
            parseToDate: parseToDate,
            parseToDateTime: parseToDateTime,
            getSelectedChart: getSelectedChart,
            setSelectedChart: setSelectedChart,
            setCorporation: setCorporation,
            getCorporation: getCorporation,
            countDatesBetween: countDatesBetween,
            attachment: attachment,
            splitByBackSlash: splitByBackSlash,
            generateUUID: generateUUID,
            getUUID: getUUID,
            // saveValidateCode: saveValidateCode,
            removeUUID: removeUUID,
            toLocalDate: toLocalDate,
            togglePanel: togglePanel,
            showPanel: showPanel,
            getEmployeeMenu: getEmployeeMenu,
            getFrequency: getFrequency,
            patientPictureDefault: patientPictureDefault,
            insuranceFrontPictureDefault: insuranceFrontPictureDefault,
            insuranceBackPictureDefault: insuranceBackPictureDefault,
            scrollToPosition: scrollToPosition,
            getEvaluationStatusClass: getEvaluationStatusClass,
            getEvaluationStatusLabelClass: getEvaluationStatusLabelClass,
            scheduleTakes: scheduleTakes,
            changeSchedule: changeSchedule,
            getPatientMedicationFilterStatus: getPatientMedicationFilterStatus,
            clearSession: clearSession,
            setStorage: setStorage,
            getStorage: getStorage,
            initBedSheetFilter: initBedSheetFilter,
            readBedSheetFromLocalStore: readBedSheetFromLocalStore,
            getFilterByFacility: getFilterByFacility,
            getGenericDelStatusFilter: getGenericDelStatusFilter,
            getFilterByCorporation: getFilterByCorporation,
            getFilterByCurrentCorporationAndType: getFilterByCurrentCorporationAndType,
            getFilterByCurrentCorporation: getFilterByCurrentCorporation,
            getChartFilter: getChartFilter,
            setChartFilter: setChartFilter,
            readCampaignOutreachFromLocalStore: readCampaignOutreachFromLocalStore,
            initCampaignOutreachFilter: initCampaignOutreachFilter,
            getHeightInchesToFeetInches: getHeightInchesToFeetInches,
            initCalendarFilter: initCalendarFilter,
            readCalendarFilterFromLocalStore: readCalendarFilterFromLocalStore,
            enableByFacilityType: enableByFacilityType,
            currentEmployeeHaveAnyCredential: currentEmployeeHaveAnyCredential,
            bytesToSize: bytesToSize
        };

        return service;

        function getStorage(attr) {
            return $sessionStorage[attr];
        }

        function setStorage(attr, value) {
            $sessionStorage[attr] = value;
        }

        function byId(id, list) {
            var i = 0;
            var finded = false;
            var value;
            while (!finded && i < list.length) {
                if (list[i].id == id) {
                    value = list[i];
                    finded = true;
                }
            }
            return value;
        }

        function isActive(data) {
            if (data) {
                try {
                    var value = data.status.toUpperCase();
                    if (value == 'ACT')
                        return true;
                    else
                        return false;
                } catch (e) {
                    console.log(e);
                }

            }
            return false;
        }

        function greaterValue(a, b) {
            if (a && b) {
                if (a >= b) {
                    return a
                } else if (a < b) {
                    return b;
                }
            } else
                return a;
        }

        function actualFacility(data) {
            if (data) {
                if (parseInt(localStorage.getItem('facid')) == data)
                    return true;
                else
                    return false;

            }
            return false;
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function isDischarge(data) {
            var actualDate = moment(new Date()).format('YYYY-MM-DD');
            if (data > actualDate)
                return false
            else
                return true
        }

        function isWaiting(data) {
            if (data == 'yes')
                return true
            else
                return false
        }

        function patientAge(dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        function countDatesBetween(toDate, fromDate) {
            var magicNumber = (1000 * 60 * 60 * 24);
            if (toDate && fromDate) {
                var dayDiff = Math.floor((toDate - fromDate) / magicNumber);
                if (angular.isNumber(dayDiff)) {
                    return dayDiff + 1;
                }
            }
        }

        function redirectSearch() {
            $state.go('search')
        }

        function redirectPatientDetails(data) {
            if (data) {
                localStorage.setItem('patId', data.chart.patientId);
                localStorage.setItem('chart', data.chart.id);
                localStorage.setItem('bed', data.chart.bedId);
            }
            $state.go('patient-details');
        }

        function sortListName(data) {
            data.sort(function (a, b) {
                var key1 = a.name;
                var key2 = b.name;

                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
            });
        }

        /**
         * Set a employee to the session storage
         * @param employee
         */
        function setCurrentEmployee(currentEmployee) {
            if (currentEmployee) {
                $sessionStorage.currentEmployee = Base64.encode(JSON.stringify(currentEmployee));
            }
        }

        /**
         * Get current employee logged from the session storage
         */
        function getCurrentEmployee() {
            if ($sessionStorage.currentEmployee)
                return JSON.parse(Base64.decode($sessionStorage.currentEmployee));
            else
                return null
        }

        /**
         * Get random avatar by gender
         */
        function getAvatar(gender) {

            var maleAvatar = [
                'content/adminLTE/img/avatar.png',
                'content/adminLTE/img/avatar4.png',
                'content/adminLTE/img/avatar5.png'
            ];

            var femaleAvatar = [
                'content/adminLTE/img/avatar2.png',
                'content/adminLTE/img/avatar3.png'
            ];

            var ramdom = 0;
            if (gender == 'MALE') {
                ramdom = Math.floor((Math.random() * 3));
                return maleAvatar[ramdom];
            } else {
                ramdom = Math.floor((Math.random() * 2));
                return femaleAvatar[ramdom];
            }
        }

        /**
         * Set a facility to the session storage
         * @param facility
         */
        function setCurrentFacility(facility) {
            if (facility) {
                $sessionStorage.selectedFacility = Base64.encode(JSON.stringify(facility));
                $rootScope.$broadcast('bluebookApp:setCurrentFacility', facility);
            } else {
                $sessionStorage.selectedFacility = null;
            }
        }

        /**
         * Get current facility from the session storage
         */
        function getCurrentFacility() {
            if ($sessionStorage.selectedFacility) {
                return JSON.parse(Base64.decode($sessionStorage.selectedFacility));
            } else {
                return null;
            }
        }

        /**
         * Set a corporation to the session storage
         * @param corporation
         */
        function setCorporation(corporation) {
            if (corporation) {
                $sessionStorage.selectedCorporation = Base64.encode(JSON.stringify(corporation));
            } else {
                $sessionStorage.selectedCorporation = null;
            }
        }

        /**
         * Get the corporation from the session storage
         */
        function getCorporation() {
            if ($sessionStorage.selectedCorporation) {
                return JSON.parse(Base64.decode($sessionStorage.selectedCorporation));
            } else {
                return null;
            }
        }

        /**
         * Set a chart to the session storage
         * @param chart
         */
        function setSelectedChart(chart) {
            if (chart) {
                $sessionStorage.selectedChart = Base64.encode(JSON.stringify(chart));
            }
        }

        /**
         * Get selected chart from session storage
         */
        function getSelectedChart() {
            if ($sessionStorage.selectedChart)
                return JSON.parse(Base64.decode($sessionStorage.selectedChart));
            else
                return null;
        }

        /**
         * Set a unassigned beds to the session storage
         * @param beds
         */
        function setUnassignedBeds(beds) {
            if (beds) {
                $sessionStorage.unassignedBeds = Base64.encode(JSON.stringify(beds));
            }
        }

        /**
         * Get current unassigned from the session storage
         */
        function getUnassignedBeds() {
            return JSON.parse(Base64.decode($sessionStorage.unassignedBeds));
        }

        function getDays() {
            return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        }

        function parseToTime(data) {
            return moment(data).format('hh:mm:ss a');
        }

        function parseToDate(data) {
            return moment(data).format('MM/DD/YYYY');
        }

        function parseToDateTime(data) {

            if (data) {
                return moment(toLocalDate(data)).format('MM/DD/YYYY hh:mm a');
            } else {
                return 'N/A';
            }
        }

        function toLocalDate(data) {
            if (data) {
                var dateUtc = moment.utc(data);
                var localDate = moment(dateUtc).local();
                return localDate;
            } else {
                return data;
            }
        }

        function attachment($file, data) {
            return $q(function (resolve, reject) {
                if ($file && $file.$error === 'pattern') {
                    reject($file.$error);
                }
                if ($file) {
                    DataUtils.toBase64($file, function (base64Data) {
                        data.file = base64Data;
                        data.fileContentType = $file.type;
                        data.name = $file.name;
                        data.size = bytesToSize($file.size);
                        resolve(data);
                    });
                }
            });
        }

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return 'n/a';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            if (i == 0) return bytes + ' ' + sizes[i];
            return (bytes / Math.pow(1024, i)).toFixed(3) + ' ' + sizes[i];
        }

        function splitByBackSlash(value) {
            return value.split('/');

        }

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now();
                ; //use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }

        function getUUID() {
            var employee = getCurrentEmployee();

            var browserUuid = $cookies.get('browserUuid' + employee.id);

            if (!browserUuid) {
                browserUuid = generateUUID();

                var d = new Date();
                d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));

                $cookies.put('browserUuid' + employee.id, browserUuid, {expires: d.toUTCString()});
            }

            return browserUuid;
        }

        function removeUUID() {
            var employee = getCurrentEmployee();
            $cookies.remove('browserUuid' + employee.id);
        }

        function togglePanel(att) {
            $rootScope.employeeMenu.menu[att].value = !$rootScope.employeeMenu.menu[att].value;
            $rootScope.employeeMenu.employee = getCurrentEmployee();
            EmployeeMenu.update($rootScope.employeeMenu);
        }

        function showPanel(att) {
            $rootScope.employeeMenu.menu[att].value = true;
            $rootScope.employeeMenu.employee = getCurrentEmployee();
            EmployeeMenu.update($rootScope.employeeMenu);
        }

        function getEmployeeMenu() {

            return $rootScope.employeeMenu;
        }

        function getFrequency(value) {
            switch (value) {
                case "1":
                    return "Every hour";
                case "2":
                    return "Every 2 hour";
                case "3":
                    return "Every 3 hour";
                case "4":
                    return "Every 4 hour";
                case "6":
                    return "Every 6 hour";
                case "8":
                    return "Every 8 hour";
                case "AM":
                    return "Once a day (AM)";
                case "HS":
                    return "Once a day (HS)";
                case "BID":
                    return "Two time a day schedule (BID)";
                case "TID":
                    return "Three times a day schedule (TID)";
                case "QID":
                    return "Four times a day schedule (QID)";
                case "SID":
                    return "Six times a day schedule";
                case "0":
                    return "Once";
            }
        }

        function patientPictureDefault() {
            return {
                picture: 'data:image/jpeg;base64,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'
            };
        }

        function insuranceFrontPictureDefault() {
            return {
                picture: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNTAiIGhlaWdodD0iMjQwIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZD0iTTAgMGgzNTB2MjQwSDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iOC45OTM3NCIgc3Ryb2tlLW1pdGVybGltaXQ9IjMiIGQ9Ik0xMy42OTggNGgzMjIuNjA0QzM0MS42NTQgNCAzNDYgOC4zNDYgMzQ2IDEzLjY5OHYyMTEuNjA0YzAgNS4zNTItNC4zNDYgOS42OTgtOS42OTggOS42OThIMTMuNjk4QzguMzQ2IDIzNSA0IDIzMC42NTQgNCAyMjUuMzAyVjEzLjY5OEM0IDguMzQ2IDguMzQ2IDQgMTMuNjk4IDR6IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+PHBhdGggZD0iTTczLjUgMzRjLTE2LjcwNiAwLTMwLjMzMyAxNC4zNzYtMzAuMzMzIDMyIDAgMTEuNDQgNS44MDkgMjEuNDQgMTQuMzkzIDI3LjA5NkM0MC4zMjMgOTkuOTM2IDI4IDExNy40NzIgMjggMTM4aDcuNTgzYy0uMDI2LTE5LjAxNiAxMi42NjctMzUuNDExIDMwLjMzNC0zOS4xODRWMTA2bDcuNTgzIDggNy41ODMtOHYtNy4xODRjMTcuNjY3IDMuNzczIDMwLjM2IDIwLjE2OCAzMC4zMzQgMzkuMTg0SDExOWMwLTIwLjUyOC0xMi4zMjMtMzguMDY0LTI5LjU2LTQ0LjkwNCA4LjkxNC01LjgwMSAxNC4zNTctMTYuMDQ3IDE0LjM5My0yNy4wOTYgMC0xNy42MjQtMTMuNjI3LTMyLTMwLjMzMy0zMnptMCA4MGwtNy41ODMgOHYxNmgxNS4xNjZ2LTE2bC03LjU4My04em0wLTcyYzEyLjYxOSAwIDIyLjc1IDEwLjY4OCAyMi43NSAyNFM4Ni4xMTkgOTAgNzMuNSA5MGMtNi4wNC4wMjEtMTEuODM4LTIuNS0xNi4xMDktNy4wMDZDNTMuMTIgNzguNDg5IDUwLjczIDcyLjM3MiA1MC43NSA2NmMwLTEzLjMxMiAxMC4xMzEtMjQgMjIuNzUtMjR6Ii8+PHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjgiIHN0cm9rZS1taXRlcmxpbWl0PSIzIiBkPSJNMTQzIDQyLjc2OWgxNjhNMTQzIDc0aDE0NU0xNDMgMTA2aDE2ME0xNDMgMTM0aDE2OCIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+PHBhdGggZD0iTTI4IDE4NXYzMGg0LjEzNnYtMzBIMjh6bTguMjczIDB2MzBoNi4yMDR2LTMwaC02LjIwNHptMTAuMzQxIDB2MzBoMTYuNTQ1di0zMEg0Ni42MTR6bTIwLjY4MSAwdjMwaDQuMTM3di0zMGgtNC4xMzd6bTguMjczIDB2MzBoNi4yMDV2LTMwaC02LjIwNXptMTAuMzQxIDB2MzBoNC4xMzZ2LTMwaC00LjEzNnptOC4yNzMgMHYzMGg4LjI3M3YtMzBoLTguMjczem0xMi40MDkgMHYzMGg0LjEzNnYtMzBoLTQuMTM2em04LjI3MyAwdjMwSDExOXYtMzBoLTQuMTM2eiIvPjxwYXRoIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbWl0ZXJsaW1pdD0iMyIgZD0iTTEzOCAyMTRoMTg2IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz48L2c+PC9zdmc+'
            };
        }

        function insuranceBackPictureDefault() {
            return {
                picture: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNTAiIGhlaWdodD0iMjQwIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZD0iTTAgMGgzNTB2MjQwSDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iOC45OTQiIHN0cm9rZS1taXRlcmxpbWl0PSIzIiBkPSJNMTMuNjk4IDQuNWgzMjIuNjA0YzUuMzUyIDAgOS42OTggNC4zNDYgOS42OTggOS42OTh2MjExLjYwNGMwIDUuMzUyLTQuMzQ2IDkuNjk4LTkuNjk4IDkuNjk4SDEzLjY5OEM4LjM0NiAyMzUuNSA0IDIzMS4xNTQgNCAyMjUuODAyVjE0LjE5OEM0IDguODQ2IDguMzQ2IDQuNSAxMy42OTggNC41eiIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+PHBhdGggZD0iTTIzMSAxODIuNXYzMGg0LjEzNnYtMzBIMjMxem04LjI3MyAwdjMwaDYuMjA0di0zMGgtNi4yMDR6bTEwLjM0MSAwdjMwaDE2LjU0NXYtMzBoLTE2LjU0NXptMjAuNjgxIDB2MzBoNC4xMzd2LTMwaC00LjEzN3ptOC4yNzMgMHYzMGg2LjIwNXYtMzBoLTYuMjA1em0xMC4zNDEgMHYzMGg0LjEzNnYtMzBoLTQuMTM2em04LjI3MyAwdjMwaDguMjczdi0zMGgtOC4yNzN6bTEyLjQwOSAwdjMwaDQuMTM2di0zMGgtNC4xMzZ6bTguMjczIDB2MzBIMzIydi0zMGgtNC4xMzZ6TTggMzIuNWgzMzV2MzdIOHoiLz48cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iOCIgc3Ryb2tlLW1pdGVybGltaXQ9IjMiIGQ9Ik0xNTUgODkuNWgxNjdNMTg3IDExNS41aDEzNU0xNTUgMTQxLjVoMTY3IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz48L2c+PC9zdmc+'
            };
        }

        function scrollToPosition(element, offset, duration) {
            var target = angular.element(document.getElementById(element));

            $document.scrollToElement(target, offset, duration);
        }

        function getEvaluationStatusClass(status) {
            switch (status) {
                case 'Pending':
                    return 'blue light';
                case 'InReview':
                    return 'yellow';
                case 'Revoked':
                    return 'blue';
                case 'Expired':
                    return 'purple';
                case 'Late':
                    return 'red';
                case 'Finalized':
                    return 'green';
                case 'Amended':
                    return 'gray light';
            }
        }

        //TODO Add style for expired status.
        function getEvaluationStatusLabelClass(status) {
            switch (status) {
                case 'Pending':
                    return 'label label-info';
                case 'InReview':
                    return 'label label-warning';
                case 'Revoked':
                    return 'label label-primary';
                case 'Expired':
                    return 'purple';
                case 'Late':
                    return 'label label-danger';
                case 'Finalized':
                    return 'label label-success';
                case 'Amended':
                    return 'label label-default';
            }
        }

        function changeSchedule(admissionMedication) {
            admissionMedication.schedules = [];
            admissionMedication.takes = [];
            admissionMedication.endDate = null;

            if (admissionMedication.frequency.id != 'AS_NEEDED') {
                admissionMedication.minimumAsNeeded = null;
            }

            if (!admissionMedication.durationDays || !admissionMedication.startDate || !admissionMedication.frequency) {
                admissionMedication.showSchedule = false;

                return;
            }

            switch (admissionMedication.frequency.id) {
                case 'EVERY_H':
                case 'EVERY_2H':
                case 'EVERY_3H':
                case 'EVERY_4H':
                case 'EVERY_6H':
                case 'EVERY_8H':
                case 'EVERY_12H':
                case 'EVERY_24H':
                case 'EVERY_48H':
                case 'EVERY_WEEK':
                case 'EVERY_TWO_WEEKS':
                case 'EVERY_MONTH': {
                    admissionMedication.showSchedule = false;
                    admissionMedication.endDate = angular.copy(admissionMedication.startDate);
                    admissionMedication.endDate.setDate(admissionMedication.endDate.getDate() + admissionMedication.durationDays - 1);
                    admissionMedication.endDate.setHours(23);
                    admissionMedication.endDate.setMinutes(59);

                    var day = angular.copy(admissionMedication.startDate);
                    var hours = parseInt(admissionMedication.frequency.hours);

                    while (admissionMedication.endDate > day) {
                        var date = new Date(day.getFullYear(), day.getMonth(), day.getDate(), day.getHours(), day.getMinutes(), 0);

                        admissionMedication.takes.push({
                            collectedDate: angular.copy(date),
                            scheduleDate: angular.copy(date),
                            canceled: false,
                            collected: false,
                            medicationTakeStatus: 'SCHEDULED'
                        });

                        day.setHours(day.getHours() + hours);
                    }

                    updatePatientActionEndDate(admissionMedication);

                    break;
                }
                case 'ONE_AM': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 1, 0, 9);

                    break;
                }
                case 'ONE_HS': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 1, 0, 21);

                    break;
                }
                case 'BID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 2, 12, 9);
                    break;
                }
                case 'TID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 3, 6, 9);

                    break;
                }
                case 'QID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 4, 3, 9);

                    break;
                }
                case 'SID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 6, 4, 2);

                    break;
                }
                case 'ONCE': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 1, 0, 9);

                    break;
                }
                case 'AS_NEEDED': {

                }
            }
        }

        function scheduleTakesIntervals(admissionMedication, count, hours, firstHour) {
            var today = new Date();
            var first = new Date(today.getFullYear(), today.getMonth(), today.getDate(), firstHour, 0, 0);

            for (var i = 0; i < count; i++) {
                admissionMedication.schedules.push({
                    xorder: i,
                    date: angular.copy(first)
                });

                first.setHours(first.getHours() + hours);
            }

            scheduleTakes(admissionMedication);
        }

        function scheduleTakes(admissionMedication) {
            admissionMedication.takes = [];
            var day = angular.copy(admissionMedication.startDate);

            for (var i = 0; i < admissionMedication.durationDays; i++) {
                var date = day;

                for (var j = 0; j < admissionMedication.schedules.length; j++) {
                    date.setHours(admissionMedication.schedules[j].date.getHours());
                    date.setMinutes(admissionMedication.schedules[j].date.getMinutes());
                    date.setSeconds(0);

                    admissionMedication.takes.push({
                        collectedDate: angular.copy(date),
                        scheduleDate: angular.copy(date),
                        canceled: false,
                        collected: false
                    });
                }
            }

            updatePatientActionEndDate(admissionMedication);
        }

        function updatePatientActionEndDate(admissionMedication) {
            if (admissionMedication.takes && admissionMedication.takes.length > 0) {
                admissionMedication.endDate = admissionMedication.takes[admissionMedication.takes.length - 1].collectedDate;
            }
        }

        function getPatientMedicationFilterStatus() {
            return {
                CURRENT: 'CURRENT',
                ADMINISTER: 'ADMINISTER',
                TODAY: 'TODAY',
                MISSED: 'MISSED',
                PATIENT_REFUSE: 'PATIENT_REFUSE'
            };
        }

        /**
         * Clear the session storage
         */
        function clearSession() {
            $sessionStorage.$reset();
        }

        function setStorage(attr, value) {
            $sessionStorage[attr] = value;
        }

        function getStorage(attr) {
            return $sessionStorage[attr];
        }

        function initBedSheetFilter() {

            return {
                buildingId: null,
                gender: null,
                searchQuery: null
            }
        }

        function initCampaignOutreachFilter() {

            return {
                campaignId: null,
                page: 1,
                searchQuery: null,
                totalItems: 0
            }
        }

        function readBedSheetFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = getStorage('filterBedSheet') == null ? initBedSheetFilter() : getStorage('filterBedSheet');
            }

            var filter = {
                buildingId: filterLS.buildingId,
                gender: filterLS.gender,
                searchQuery: filterLS.searchQuery
            }

            return filter;
        }

        function readCampaignOutreachFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = getStorage('filterCampaignOutreach') == null ? initCampaignOutreachFilter() : getStorage('filterCampaignOutreach');
            }

            var filter = {
                campaignId: filterLS.campaignId,
                page: filterLS.page,
                searchQuery: filterLS.searchQuery,
                totalItems: filterLS.totalItems
            }

            return filter;
        }

        function getFilterByFacility(facility) {
            return {id: facility.id};
        }

        function getGenericDelStatusFilter() {
            return {
                query: {
                    bool: {
                        must: [{term: {delStatus: false}}]
                    }
                }
            }
        }

        function getFilterByCorporation(corporation) {
            return {
                query: {
                    bool: {
                        must: [
                            {term: {delStatus: false}},
                            {
                                bool: {
                                    should: [
                                        {"term": {"corporationId": corporation.id}},
                                        {"term": {"corporation.id": corporation.id}}
                                    ]
                                }
                            }
                        ]
                    }
                }
            }
        }

        function getFilterByCurrentCorporationAndType(type) {
            var corporation = getCorporation();

            return {id: corporation.id, relationalType: type};
        }

        function getFilterByCurrentCorporation() {
            var corporation = getCorporation();

            return {id: corporation.id};
        }

        function setChartFilter(filter) {
            $sessionStorage.chartFilter = filter;
        }

        function getChartFilter() {
            return $sessionStorage.chartFilter;
        }

        function getHeightInchesToFeetInches(height) {
            return Math.floor(height / 12) + "' - " + height % 12 + "''";
        }

        function initCalendarFilter() {
            return {
                employeesSelection: [],
                buildingSelection: [],
                groupSessionStatusesSelect: [],
                searchQuery: "",
                toggleSidebar: 0,
                start: null,
                end: null
            }
        }

        function readCalendarFilterFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = CoreService.getStorage('filterCalendar');
            }
            var toggleSidebar = (filterLS.employeesSelection.length > 0 || filterLS.buildingSelection.length > 0 || filterLS.groupSessionStatusesSelect.length > 0 || filterLS.searchQuery != "") ? 1 : 0;

            var filter = {
                employeesSelection: filterLS.employeesSelection,
                buildingSelection: filterLS.buildingSelection,
                groupSessionStatusesSelect: filterLS.groupSessionStatusesSelect,
                searchQuery: filterLS.searchQuery,
                toggleSidebar: toggleSidebar,
                start: new Date(filterLS.start),
                end: new Date(filterLS.end)
            }

            return filter;
        }

        function enableByFacilityType(facility, field) {
            if (facility.facilityType && facilityField[facility.facilityType]) {

                return facilityField[facility.facilityType][field];
            }

            return true;
        }

        function currentEmployeeHaveAnyCredential(credentials) {
            return _.intersection(getCurrentEmployee().credentials,
                _.map(credentials, function (credential) {
                    return credential.name;
                })
            ).length > 0;
        }
    }
})();
